export class RequestError {
    httpCode: number;
    code: string;
    name: string;
    messages: string[];
}
